import type { Tables } from '~/types/database-helpers';

export const sumBaseballRecords = (schedule1: Tables<'schedules'>): string => {
  if (!schedule1) return `0-0-0`;
  const totalWins = (schedule1.conf_win || 0) + (schedule1.ooc_win || 0);
  const totalLosses = (schedule1.conf_loss || 0) + (schedule1.ooc_loss || 0);
  const totalTies = (schedule1.conf_tie || 0) + (schedule1.ooc_tie || 0);

  return `${totalWins}-${totalLosses}-${totalTies}`;
};
